import { LayoutService } from 'src/app/layout/layout.service';
import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[locale]'
})
export class LocaleDirective implements AfterViewInit {

  constructor(
    private layoutService: LayoutService,
    private el: ElementRef,
    private _renderer: Renderer2
  ) {
  }

  ngAfterViewInit(): void {
    let text = this.el.nativeElement.innerText;
    const translatedText = this.layoutService.translate(text);
    text = translatedText;
  }
}
